import { HostAdapter, HostAdapterProvider } from "../platform";
import { AuthProvider } from "./AuthContext";
import { store } from "../store/store";
import React from "react";
import { Provider } from "react-redux";
import { ColorPreferenceProvider } from "../hooks/useColorPreference";
import { TooltipProvider } from "../components/ui/tooltip";
import ErrorBoundary from "../components/error/ErrorBoundary";

export interface ProviderProps {
  /**
   * The running host, resolved by the entry point rather than in here.
   *
   * Each entry knows its own host and imports only that adapter -- the document
   * hosts through platform/documentHosts, Outlook through platform/outlook -- which
   * is what keeps one host's document layer out of the other's bundle.
   */
  adapter: HostAdapter;
  children: React.ReactNode;
}

const Providers: React.FC<ProviderProps> = ({ adapter, children }) => {
  return (
    <ErrorBoundary>
      <HostAdapterProvider adapter={adapter}>
        <AuthProvider>
          <Provider store={store}>
            {/* No theme provider: colours are CSS variables (styles/), and the scheme is
                the class ColorPreferenceProvider puts on <html>. The body's font, colours
                and background are the stylesheet's base layer. */}
            <ColorPreferenceProvider>
              {/* One provider for every Radix tooltip, so moving between two tooltipped
                  buttons opens the second at once instead of waiting out the delay again. */}
              <TooltipProvider delayDuration={400}>{children}</TooltipProvider>
            </ColorPreferenceProvider>
          </Provider>
        </AuthProvider>
      </HostAdapterProvider>
    </ErrorBoundary>
  );
};

export default Providers;
